import React from 'react';
import { string, object, func, number, array, oneOf } from 'prop-types';
import { getDisplayableSpreadDishes, toggleDishToPaymentAssociation } from '../../utils/PayPerDishUtils';
import ModalLayout from '../ModalLayout';
import BasicModalLayoutFooter from '../ModalLayout/BasicModalLayoutFooter';
import CheckboxGroup from '../EditDish/EditDishCheckboxGroup';
import Checkbox from '../Checkbox';
import TitlePrice from '../TitlePrice';
import _ from 'lodash';
import CreditCardLine from './CreditCardLine';
import { PaymentTypes } from '../../utils/constants';
import CashLine from './CashLine';
import styles from './AssociateDish.scss';
import { Text } from 'wix-style-react';

export default class AssociateDish extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { ppd: [], pendingPpd: [] };
  }

  static getDerivedStateFromProps(nextProps, currentState) {
    const { ppd } = nextProps;
    if (!_.isEqual(ppd, currentState.ppd)) {
      return { ppd, pendingPpd: _.cloneDeep(ppd) };
    } else {
      return null;
    }
  }

  renderFooter() {
    return (
      <BasicModalLayoutFooter
        data-hook="associate-dish-footer"
        onOkClick={this.handleOkClick}
        onCancelClick={this.props.onRequestClose}
        okText="Done"
      />
    );
  }

  handleOkClick = () => {
    const paymentAssociations = this.state.pendingPpd;
    this.props.setPaymentAssociations({ paymentAssociations });
    this.props.onRequestClose();
  };

  handleChange = ({ paymentIndex, orderItemIndex }) => {
    const pendingPpd = toggleDishToPaymentAssociation({ ppd: this.state.pendingPpd, paymentIndex, orderItemIndex });
    this.setState({ pendingPpd });
  };

  render() {
    const {
      orderItems,
      payments,
      itemsHash,
      currency,
      i18n,
      locale,
      paymentIndex,
      onRequestClose,
      collectionMethod,
    } = this.props;
    const ppd = this.state.pendingPpd;

    const list = getDisplayableSpreadDishes({
      orderItems,
      payments,
      itemsHash,
      currency,
      i18n,
      locale,
      ppd,
      paymentIndex,
    });

    return (
      <ModalLayout title="Select Dish" footer={this.renderFooter()} onCloseClick={onRequestClose}>
        <div className={styles.wrapper}>
          <CheckboxGroup>
            {list.map((item, orderItemIndex) => {
              const checked = item.checked;
              const indeterminate = item.indeterminate;
              const title = (
                <Text size="medium" weight="normal" tagName="div">
                  {item.title}
                </Text>
              );
              const subtitle = (
                <Text size="small" weight="normal" secondary tagName="div">
                  {item.choicesStr}
                </Text>
              );
              const price = (
                <Text size="medium" weight="normal">
                  {item.price}
                </Text>
              );

              const Line = item.paymentType === PaymentTypes.CREDIT ? CreditCardLine : CashLine;

              return (
                <Checkbox
                  lineHeight={24}
                  key={orderItemIndex}
                  checked={checked}
                  indeterminate={indeterminate}
                  dataHook="associate-dish-checkbox"
                  onChange={() => this.handleChange({ paymentIndex, orderItemIndex })}
                >
                  <TitlePrice title={title} subtitle={subtitle} price={price} />
                  {indeterminate && (
                    <Line
                      locale={locale}
                      block
                      collectionMethod={collectionMethod}
                      {...item.displayablePaymentMethod}
                    />
                  )}
                </Checkbox>
              );
            })}
          </CheckboxGroup>
        </div>
      </ModalLayout>
    );
  }
}

AssociateDish.displayName = 'AssociateDish';
AssociateDish.propTypes = {
  orderItems: array,
  payments: array,
  itemsHash: object,
  currency: string,
  i18n: object,
  locale: string,
  ppd: array,
  paymentIndex: number,
  onRequestClose: func,
  setPaymentAssociations: func,
  collectionMethod: oneOf(['online', 'cod', 'phone']).isRequired,
};
